module.exports = __webpack_public_path__ + "static/media/approve_icon.1fb1eb5a.svg";